import { useState, useEffect } from "react";
import { api } from "../../services/api";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function ChangePassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const operatorId = location.state?.operator_id;
  const token = localStorage.getItem("token");

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    // Si ya tenemos token, el usuario no debería pasar por aquí
    if(token){
      navigate("/", {replace: true});
      return;
    }

    if(!operatorId){
      navigate("/login", {replace: true});
    }

  }, [operatorId, token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (newPassword !== confirmPassword) {
      return setError(t("changePassword.errors.mismatch"));
    }

    setLoading(true);
    try {
      await api.patch(
        `/operator/${operatorId}/change-password`,
        {
          current_password: currentPassword,
          new_password: newPassword,
        }
      );

      navigate("/login", {replace: true});
    } catch (err) {
      setError(
        err?.response?.data?.message || t("changePassword.errors.generic")
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded shadow w-full max-w-md space-y-4"
      >
        <h1 className="text-xl font-semibold text-center">
          {t("changePassword.title")}
        </h1>

        <input
          type="password"
          placeholder={t("changePassword.fields.current")}
          value={currentPassword}
          onChange={(e) => setCurrentPassword(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />

        <input
          type="password"
          placeholder={t("changePassword.fields.new")}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />

        <input
          type="password"
          placeholder={t("changePassword.fields.confirm")}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
          className="w-full border px-3 py-2 rounded"
        />

        {error && (
          <p className="text-red-600 text-sm">{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#01839C] text-white py-2 rounded hover:bg-[#016b80]"
        >
          {loading
            ? t("changePassword.actions.saving")
            : t("changePassword.actions.submit")}
        </button>
      </form>
    </div>
  );
}
